import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { StoreService } from '../services';
import { MQService, MQComponent } from '@ngxsuit';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss']
})
export class LayoutComponent extends MQComponent implements OnInit {
    private route_param_subscriber: any;
    private storeName: string;
    constructor(public router: Router,
        private route: ActivatedRoute,
        protected mq: MQService,
        private storeService: StoreService
    ) {
        super(mq);
    }

    ngOnInit() {
        if (this.router.url === '/') {
            this.router.navigate(['/dashboard']);
        }
        this.route_param_subscriber = this.route.params.subscribe(params => {
            this.storeName = params['store_id'];
            this.storeService.callWhenStoresReady(() => {
                this.storeService.changeStore(this.storeName, this.router);
            })
        });
        super.listenOn('stores-ready', msg => {
            this.storeService.changeStore(this.storeName, this.router);
        })
    }

    ngOnDestroy(): void {
        this.route_param_subscriber.unsubscribe();
    }
}